/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current_members: NonNullable<unknown>, max_members: NonNullable<unknown> }} Admin_Dashboard_Activity_Member_LimitInputs */

const en_admin_dashboard_activity_member_limit = /** @type {(inputs: Admin_Dashboard_Activity_Member_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.current_members} / ${i?.max_members} members reached. To add more than ${i?.max_members} members please`)
};

const de_admin_dashboard_activity_member_limit = /** @type {(inputs: Admin_Dashboard_Activity_Member_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.current_members}/${i?.max_members} Mitglieder erreicht. Um mehr als ${i?.max_members} Mitglieder hinzuzufügen, bitte`)
};

const es_admin_dashboard_activity_member_limit = /** @type {(inputs: Admin_Dashboard_Activity_Member_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.current_members}/${i?.max_members} miembros alcanzad@s. Para añadir más de ${i?.max_members} miembros, por favor`)
};

const fr_admin_dashboard_activity_member_limit = /** @type {(inputs: Admin_Dashboard_Activity_Member_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vous avez atteint ${i?.current_members}/${i?.max_members} membres. Pour continuer à ajouter de nouveaux membres, veuillez`)
};

const it_admin_dashboard_activity_member_limit = /** @type {(inputs: Admin_Dashboard_Activity_Member_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.current_members} / ${i?.max_members} membri raggiunti. Per aggiungere più di ${i?.max_members} membri, si prega di`)
};

const pt_br2_admin_dashboard_activity_member_limit = /** @type {(inputs: Admin_Dashboard_Activity_Member_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.current_members} / ${i?.max_members} membros incluídos. Para adicionar mais de ${i?.max_members} membros, por favor`)
};

const pl_admin_dashboard_activity_member_limit = /** @type {(inputs: Admin_Dashboard_Activity_Member_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.current_members} / ${i?.max_members} członków osiągnięto. Aby dodać więcej niż ${i?.max_members} członków, proszę`)
};

const hu_admin_dashboard_activity_member_limit = /** @type {(inputs: Admin_Dashboard_Activity_Member_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.current_members} / ${i?.max_members} tag elérve. Több mint ${i?.max_members} tag hozzáadásához kérjük`)
};

const ro_admin_dashboard_activity_member_limit = /** @type {(inputs: Admin_Dashboard_Activity_Member_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.current_members} / ${i?.max_members} membri atinsi. Pentru a adauga mai mult de ${i?.max_members} membri va rugam sa`)
};

/**
* | output |
* | --- |
* | "{current_members} / {max_members} members reached. To add more than {max_members} members please" |
*
* @param {Admin_Dashboard_Activity_Member_LimitInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_activity_member_limit = /** @type {((inputs: Admin_Dashboard_Activity_Member_LimitInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Activity_Member_LimitInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_activity_member_limit(inputs)
	if (locale === "de") return de_admin_dashboard_activity_member_limit(inputs)
	if (locale === "es") return es_admin_dashboard_activity_member_limit(inputs)
	if (locale === "fr") return fr_admin_dashboard_activity_member_limit(inputs)
	if (locale === "it") return it_admin_dashboard_activity_member_limit(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_activity_member_limit(inputs)
	if (locale === "pl") return pl_admin_dashboard_activity_member_limit(inputs)
	if (locale === "hu") return hu_admin_dashboard_activity_member_limit(inputs)
	return ro_admin_dashboard_activity_member_limit(inputs)
});
export { admin_dashboard_activity_member_limit as "admin.dashboard.activity_member_limit" }